import { GET_QUESTIONS } from "../constants/constants";

const initialSessionState = { questions: [] };

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_QUESTIONS:
      return {
        ...state,
        questions: [...action.questions.content],
      };
    default:
      return state;
  }
};

export const getQuestionsList = (state) => state.questionsReducer.questions;
